import { socketClient } from 'pages/views/devices/socketClient';
import { removeDisplayMsrp } from 'pages/views/devices/utils/storage';

import { CFD_MESSAGES } from '../socketClient/types';

export const initHub = async () => {
  await window.merchantos.session.init();

  removeDisplayMsrp();

  socketClient.connect();

  // Handle the case where the register is closed.
  window.merchantos.asyncSubscribe.subscribeToFormCall('closing_counts', () => {
    socketClient.send(CFD_MESSAGES.HIDE_SALE);
  });
};
